import Manifest from './manifest'
import Request from '../utils/reguest'
import Status from '../utils/status'
import Utils from '../utils/utils'
import Markers from './markers'
import Timer from './timer'

let network   = new Request()
let connected = true

function init(){
    // Периодически перепроверяем зеркала и переключаемся на самое быстрое.
    Timer.add(1000 * 60 * 15, ()=>{
        task()
    })
}

/**
 * Переключить активное зеркало бренд-API (только в памяти, без сохранения —
 * на каждый запуск зеркало выбирается заново, чтобы не залипать на устаревшем).
 */
function redirect(to){
    if(!to || Manifest.api_mirrors.indexOf(to) < 0) return

    if(Manifest.cub_site !== to){
        console.log('Mirrors', 'redirect api to', to)

        Manifest.cub_site = to
    }
}

/**
 * Пингануть одно зеркало через /api/checker.
 * Сервер возвращает обратно переданную случайную строку — так мы убеждаемся,
 * что отвечает именно наш бэкенд, а не промежуточная заглушка.
 */
function check(protocol, mirror, call, timeout){
    let random = Math.random() + ''

    network.silent(protocol + mirror + '/api/checker', (str)=>{
        call(str == random)
    }, ()=>{
        call(false)
    }, {
        data: random,
    }, {
        dataType: 'text',
        timeout: timeout || 1000 * 7
    })
}

/**
 * Протестировать все зеркала бренд-API на текущем протоколе и выбрать самое
 * быстрое из ответивших. Результат применяется через redirect() (в памяти).
 */
function select(call){
    let protocol = Utils.protocol()
    let mirrors  = Manifest.api_mirrors
    let status   = new Status(mirrors.length)
    let alive    = []

    status.onComplite = ()=>{
        if(alive.length){
            // Самое быстрое — с наименьшим временем ответа.
            alive.sort((a, b)=> a.time - b.time)

            console.log('Mirrors', 'fastest api:', alive[0].mirror, alive[0].time + 'ms', '|', alive.map(m=> m.mirror + ' ' + m.time + 'ms').join(', '))

            redirect(alive[0].mirror)

            connected = true

            Markers.normal('mirrors')
        }
        else{
            console.error('Mirrors', 'all api offline', mirrors)

            connected = false

            Markers.error('mirrors')
        }

        if(call) call()
    }

    console.log('Mirrors', 'start api test', protocol, mirrors)

    mirrors.forEach((mirror)=>{
        let start = Date.now()

        check(protocol, mirror, (result)=>{
            if(result){
                console.log('Mirrors', protocol + mirror, 'online', (Date.now() - start) + 'ms')

                alive.push({ mirror, time: Date.now() - start })

                status.append(mirror, true)
            }
            else{
                console.warn('Mirrors', protocol + mirror, 'offline')

                status.error()
            }
        }, 1000 * 5)
    })
}

/**
 * Стартовая/периодическая задача: выбрать самое быстрое рабочее зеркало.
 * До завершения замера используется api_mirrors[0] (дефолт из манифеста).
 */
function task(call){
    if(!window.lampa_settings.mirrors) return call && call()

    select(call)
}

/**
 * Ручной тест зеркал (без гейта lampa_settings.mirrors).
 */
function test(call){
    select(call)
}

export default {
    init,
    task,
    connected: ()=>connected,
    test
}
